import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { connect } from 'react-redux';
import { requestPrevWorkOrderList } from '../actions/workOrderList';
import { WorkOrderList } from '../components/work-order-list/work-order-list';
import { InfiniteScroller } from '../../../components/InfiniteScroll/infinite-scroller';
import { EmptyState } from 'components/InfoBox/empty-state';
const PreviousWorkOrderListContainer = ({ workOrders = [], fetchPreviousWorkOrders, isFetching, workOrderRequest, languageStrings, }) => {
    const hasMore = !isFetching && (workOrderRequest ? !workOrderRequest.last : true);
    useEffect(() => {
        if (!isFetching)
            fetchPreviousWorkOrders();
    }, []);
    if (!workOrders.length) {
        return (_jsx(EmptyState, { title: languageStrings.UNDONE.TITLE, text: languageStrings.UNDONE.SUB_TITLE }));
    }
    return (_jsx(InfiniteScroller, { hasMore: hasMore, onLoadMore: () => fetchPreviousWorkOrders(workOrderRequest.number + 1), isFetching: isFetching, children: _jsx(WorkOrderList, { workOrders: workOrders }) }));
};
const mapDispatchToProps = (dispatch) => ({
    fetchPreviousWorkOrders: (pageNumber) => dispatch(requestPrevWorkOrderList(pageNumber)),
});
const mapStateToProps = (state) => ({
    workOrders: state.previousWorkOrders.workOrders,
    isFetching: state.previousWorkOrders.isFetching,
    workOrderRequest: state.previousWorkOrders.latestPreviousWorkOrderRequest,
    languageStrings: state.NOB.NO_WORK_ORDERS,
});
export default connect(mapStateToProps, mapDispatchToProps)(PreviousWorkOrderListContainer);
